import { Link } from "react-router-dom";

interface BrandProps {
  compact?: boolean;
  linked?: boolean;
}

function BrandContent() {
  return (
    <>
      <span className="brand__mark" aria-hidden="true">
        <span className="brand__spark">+</span>
        <span className="brand__stroke" />
      </span>
      <span className="brand__words">
        <strong>PERFECT</strong>
        <span>DRAW</span>
      </span>
    </>
  );
}

export function Brand({ compact = false, linked = true }: BrandProps) {
  const className = `brand${compact ? " brand--compact" : ""}`;
  return linked ? (
    <Link className={className} to="/" aria-label="PERFECT DRAW home">
      <BrandContent />
    </Link>
  ) : (
    <span className={className} aria-label="PERFECT DRAW">
      <BrandContent />
    </span>
  );
}
